
import HomePage from '../pages/home.vue'
// import FormPage from '../pages/form.vue'
import LandPage from '../pages/land.vue'
import NotificationsPage from '../pages/notifications.vue'
import AddItemPage from '../pages/add-item.vue'

import DynamicRoutePage from '../pages/dynamic-route.vue'
import RequestAndLoad from '../pages/request-and-load.vue'
import NotFoundPage from '../pages/404.vue'

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  // {
  //   path: '/form/',
  //   component: FormPage,
  // },
  {
    path: '/land/',
    component: LandPage,
  },
  {
    path: '/notifications/',
    component: NotificationsPage,
  },
  {
    path: '/add-item/',
    component: AddItemPage,
  },
  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;